import React, { useState, useEffect } from 'react';
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from './firebase';
import { FileText } from 'lucide-react'; // <--- 1. IMPORT AGGIUNTO

const ThumbnailImage = ({ item }) => {
  const [src, setSrc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchThumbnail = async () => {
      // 2. CORREZIONE: SE NON È UN'IMMAGINE E NON È UN VIDEO (es. PDF), NON CERCARE LA FOTO
      if (item.mimeType && !item.mimeType.startsWith('image/') && !item.mimeType.startsWith('video/')) {
        if (isMounted) {
          setSrc(null); // Nessuna sorgente immagine
          setLoading(false);
        }
        return;
      }

      // Se non c'è storagePath (vecchie foto) o è un video, usiamo l'url originale
      if (!item.storagePath || (item.mimeType && item.mimeType.startsWith('video/'))) {
        if (isMounted) {
          setSrc(item.url);
          setLoading(false);
        }
        return;
      }

      try {
        // Calcola il percorso della miniatura:
        // Da "photos/123_foto.jpg" a "photos/123_foto_400x400.jpg"
        
        const lastDotIndex = item.storagePath.lastIndexOf('.');
        if (lastDotIndex === -1) throw new Error("No extension");

        const pathWithoutExt = item.storagePath.substring(0, lastDotIndex);
        const ext = item.storagePath.substring(lastDotIndex);
        const thumbPath = `${pathWithoutExt}_400x400${ext}`;

        const thumbUrl = await getDownloadURL(ref(storage, thumbPath));
        
        if (isMounted) setSrc(thumbUrl);

      } catch (err) {
        // Se la miniatura non esiste (errore o non ancora creata), usa l'originale
        if (isMounted) setSrc(item.url);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchThumbnail();

    return () => { isMounted = false; };
  }, [item]);

  // 3. CORREZIONE: SE NON C'È SRC (es. è un PDF), MOSTRA ICONA
  if (!loading && !src) {
    return (
      <div style={{width:'100%', height:'100%', background:'#f0f0f0', display:'flex', alignItems:'center', justifyContent:'center'}}>
         <FileText size={40} color="#ccc" />
      </div>
    );
  }

  return (
    <div style={{width:'100%', height:'100%', background:'#f0f0f0'}}>
      {src && (
        <img 
          src={src} 
          alt="thumb" 
          loading="lazy"
          style={{
            width: '100%', 
            height: '100%', 
            objectFit: 'cover',
            opacity: loading ? 0 : 1,
            transition: 'opacity 0.3s ease'
          }} 
        />
      )}
    </div>
  );
};

export default ThumbnailImage;